import MainLayout from "@/components/layouts/MainLayout";
import store from "@/store";

const changeMenuDistributor = () => {
  store.dispatch("changeMenu", "distributor_application");
};

export default [
  {
    path: "/distributor_application/data_verification",
    name: "distributor_application.data_verification.index",
    component: () =>
      import("@/views/borrower/data_verification/DistributorView.vue"),
    meta: {
      layout: MainLayout,
      pageTitle: "Verifikasi Data",
      financingProgram: "distributor",
      breadcrumbs: [
        {
          name: "Permohonan Debitur Distributor",
          url: "/",
        },
        {
          name: "Verifikasi Data",
          url: "/",
        },
      ],
    },
    beforeEnter: changeMenuDistributor,
  },
  {
    path: "/distributor_application/data_verification/:id/legal",
    name: "distributor_application.data_verification.legal",
    component: () => import("@/views/borrower/data_verification/LegalView.vue"),
    meta: {
      financingProgram: "distributor",
    },
  },
  {
    path: "/distributor_application/data_verification/:id/individual",
    name: "distributor_application.data_verification.individual",
    component: () =>
      import("@/views/borrower/data_verification/IndividualView.vue"),
    meta: {
      financingProgram: "distributor",
    },
  },
  {
    path: "/distributor_application/data_verification/:id/approval",
    name: "distributor_application.data_verification.approval",
    component: () =>
      import("@/views/borrower/data_verification/ApprovalView.vue"),
    meta: {
      financingProgram: "distributor",
    },
  },
  {
    path: "/distributor_application/credit_verification",
    name: "distributor_application.credit_verification.index",
    component: () =>
      import("@/views/borrower/credit_verification/DistributorView.vue"),
    meta: {
      layout: MainLayout,
      pageTitle: "Verifikasi Komite Kredit",
      financingProgram: "distributor",
      breadcrumbs: [
        {
          name: "Permohonan Debitur Distributor",
          url: "/",
        },
        {
          name: "Verifikasi Komite Kredit",
          url: "/",
        },
      ],
    },
    beforeEnter: changeMenuDistributor,
  },
  {
    path: "/distributor_application/credit_verification/:id",
    name: "distributor_application.credit_verification.show",
    component: () =>
      import("@/views/borrower/credit_verification/ShowView.vue"),
    meta: {
      financingProgram: "distributor",
    },
  },
  {
    path: "/distributor_application/loan_limit",
    name: "distributor_application.loan_limit.index",
    component: () => import("@/views/borrower/loan_limit/DistributorView.vue"),
    meta: {
      layout: MainLayout,
      pageTitle: "Loan Limit",
      financingProgram: "distributor",
      breadcrumbs: [
        {
          name: "Permohonan Debitur Distributor",
          url: "/",
        },
        {
          name: "Loan Limit",
          url: "/",
        },
      ],
    },
    beforeEnter: changeMenuDistributor,
  },
  {
    path: "/distributor_application/loan_limit/:id",
    name: "distributor_application.loan_limit.show",
    component: () => import("@/views/borrower/loan_limit/ShowView.vue"),
    meta: {
      financingProgram: "distributor",
    },
  },
];
